import { graphql } from '../../graphql';

export const editingItemQuery = graphql(`
  query EditingItem($itemId: ID!) {
    itemEdit(itemId: $itemId) {
      item {
        title
        isLeased
        location {
          fullName
        }
        category {
          id
        }
      }
      edit {
        address
        city {
          id
          longitude
          latitude
          locations {
            id
            locationGroupId
          }
        }
        latitude
        longitude
        area {
          units
          value
        }
        contactName
        description
        floor
        floors
        hasBillOfSale
        hasMortgage
        hasRepair
        landArea {
          units
          value
        }
        canEditLocation
        region {
          id
          name
        }
        township {
          id
          name
        }
        landmarks {
          id
          name
          locationGroupId
        }
        isPaidDaily
        photos {
          thumbnail
        }
        price {
          currency
          total
        }
        rooms
      }
    }
  }
`);
